/*
* CF = Code -> Feature
* */

export class CFTranslatorUtil {
  public static Prescriptions = {
    default: 'Prescriptions',
    snakeCase: 'prescriptions'
  };

  public static AdminBilling = {
    default: 'Billing',
    snakeCase: 'admin-billing'
  };

  public static UserAdmin = {
    default: 'Users',
    snakeCase: 'users-admin'
  };

  public static Forms = {
    default: 'Forms',
    snakeCase: 'forms'
  };

  public static Builder = {
    default: 'PrescriptionBuilder',
    snakeCase: 'builder'
  };

  public static SeriesBuilder = {
    default: 'PrescriptionBuilder',
    mySeries: 'MyPrescriptions',
    newSeriesTemplate: 'NewPrescription',
    snakeCase: 'prescription-builder'
  };

  public static EventBuilder = {
    default: 'DoseBuilder',
    snakeCase: 'dose-builder',
    events: 'Doses',
    details: 'DoseDetails'
  };

  public static PatientActivityPlan = {
    default: 'TreatmentPlan',
    summary: 'TreatmentPlanSummary',
    item: 'Treatment',
    newItem: 'NewTreatment',
    snakeCase: 'treatment-plan'
  };
}
